<template>
    <rkm-form
        v-if="model"
        ref="Form"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidadeId"
                    label="Unidade executante"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competenciaId"
                    label="Competência"
                    show-default-option
                    text-field="valor"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidadeId: { required: true },
                competenciaId: { required: true },
            }
        },
    },
    created() {
        this.repositories.exportacao = this.getConectaSusRepository('apac.exportacao')
    },
    data: () => ({
        form: null,
        model: null,
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.exportacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        this.repositories.exportacao.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                if (response.data.inconsistencias > 0) {
                                    this.showWarningNotification(`
                                        Arquivo gerado com sucesso:
                                        <ul>
                                            <li>Registros consistentes: <strong>${response.data.consistencias}</strong></li>
                                            <li>Registros inconsistentes: <strong>${response.data.inconsistencias}</strong></li>
                                        </ul>
                                    `)
                                } else {
                                    this.showSaveNotification(`
                                        Arquivo gerado com sucesso:
                                        <ul>
                                            <li>Registros consistentes: <strong>${response.data.consistencias}</strong></li>
                                        </ul>
                                    `)
                                }

                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>